import React from 'react';
import type { Showcase, ShowcaseProperty, ShowcaseResource } from '../../types';
import { MapPin } from 'lucide-react';

interface MapSectionProps {
  showcase: Showcase;
  property: ShowcaseProperty;
  resources: ShowcaseResource[];
  brandColour: string;
  darkMode?: boolean;
}

export default function MapSection({ showcase, property, resources, brandColour, darkMode: dm }: MapSectionProps) {
  const hasCoords = property.latitude && property.longitude;
  const address = [property.address_line_1, property.address_line_2, property.town_city, property.county_state, property.postcode_zip]
    .filter(Boolean)
    .join(', ');

  if (!hasCoords && !address) return null;

  const mapQuery = hasCoords
    ? `${property.latitude},${property.longitude}`
    : encodeURIComponent(address);

  return (
    <section className={`py-16 ${dm ? 'bg-slate-900' : 'bg-white'}`}>
      <div className="max-w-5xl mx-auto px-8">
        <h2 className={`text-2xl font-bold mb-8 ${dm ? 'text-white' : 'text-slate-900'}`}>Location</h2>

        <div className="rounded-xl overflow-hidden shadow-lg">
          <iframe
            src={`https://maps.google.com/maps?q=${mapQuery}&t=m&z=15&output=embed`}
            className="w-full h-[400px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Property location map"
          />
        </div>

        {address && (
          <div className={`flex items-center gap-2 mt-4 ${dm ? 'text-slate-300' : 'text-slate-600'}`}>
            <MapPin className={`w-5 h-5 ${dm ? 'text-slate-500' : 'text-slate-400'}`} />
            <span>{address}</span>
          </div>
        )}
      </div>
    </section>
  );
}
